import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";

const ErrorPage = () => {
    return (
        <div className="error-page-wrapper">
            <div className="error-page-content text-center">
                <div className="icon-box">
                    <div className="ok-icon xmb-5"><IconName name="missed" className="icon"/></div>
                </div>
                <div className="error-text xmb-10"><span
                    className="text">سفارش SYD-119435 ثبت شد اما پرداخت ناموفق بود.</span></div>
                <div className="payment-text xmb-2"><span className="text">برای جلوگیری از لغو سیستمی سفارش، تا ۱ ساعت آینده پرداخت را انجام دهید.</span>
                </div>
                <div className="back-money"><span className="text">چنان‌چه طی این فرآیند مبلغی از حساب شما کسر شده است، طی ۷۲ ساعت آینده به حساب شما باز خواهد گشت.</span>
                </div>
                <div className="buttons-error d-flex justify-content-around align-items-center xmb-8">
                    <div className="order-button"><a href="#">مرور سفارش</a></div>
                    <div className="retry-button"><a href="#">تلاش مجدد</a></div>
                </div>

                <div className="cancel-order">
                    <a href="#">لغو سفارش</a>
                </div>
            </div>
        </div>
    );
};

export default ErrorPage;
